/** One rule for what counts as an email address (mirror of backend utils/emailAddress). */
export const isEmailAddress = (v: string) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim());
